import { PaginationType } from './general';

export enum COIN_RACE_STATUS {
	ACTIVE = 'active',
	PENDING = 'pending',
	COMPLETED = 'completed'
}

export enum COIN_RACE_TYPE {
	MY_RACES = 'my_races',
	FIXED_PRIZE = 'fixed_prize',
	JACKPOT_PRIZE = 'jackpot_prize'
}

export enum COIN_RACE_ORDER {
	ASC = 'asc',
	DESC = 'desc'
}

export type CoinRaceType = {
	id: string;
	name: string;
	start_date: string;
	end_date: string;
	duration_seconds: number;
	status: COIN_RACE_STATUS;
	reward_type: COIN_RACE_TYPE;
	jackpot_points: number;
	subscriptions_count: number;
	prizes_count: number;
	subscribed?: boolean;
	can_subscribe?: boolean;
};

export type CoinRacesResponse = {
	status: string;
	coin_races: CoinRaceType[];
	completed_coin_races: CoinRaceType[];
	pagination: PaginationType;
};

export type CoinRacePrizeType = {
	position: number;
	winner_range_from: number;
	winner_range_to: number;
	reward_value: number;
	image: string | null;
	description: string | null;
};

export type CoinRaceLeaderboardType = {
	position: number;
	user_pm_id: string;
	score: number;
	reward_value: number;
};

export type CoinRaceDetailedType = {
	status: COIN_RACE_STATUS;
	start_date: string;
	end_date: string;
	duration_seconds: number;
	name: string;
	description: string;
	rules_and_conditions: string;
	jackpot_points: number;
	reward_type: COIN_RACE_TYPE;
	subscribed: boolean;
	can_subscribe: boolean;
};

export type CoinRaceDetailsCurrentUserType = {
	position: number;
	user_pm_id: string;
	score: number;
	reward_value: string | null;
};

export type CoinRaceDetailedResponse = {
	coin_race: CoinRaceDetailedType;
	prizes: CoinRacePrizeType[];
	leaderboard: CoinRaceLeaderboardType[];
	current_user_in_leaderboard: boolean;
	pagination: PaginationType;
	current_user: CoinRaceDetailsCurrentUserType | null;
};

export interface CoinRaceFiltersState {
	status: COIN_RACE_STATUS;
	selectedType?: COIN_RACE_TYPE;
	sortOrder: COIN_RACE_ORDER;
}

export type CoinRaceFilter = {
	id: COIN_RACE_TYPE;
	name: string;
	icon: React.ReactNode;
};

export type CoinRaceSortOption = {
	label: string;
	value: COIN_RACE_ORDER;
};
